 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"app-main-EV-space-EV-space-module":"app-main-EV-space-EV-space-module","app-main-asset-asset-module":"app-main-asset-asset-module","app-main-callback-management-callback-management-module":"app-main-callback-management-callback-management-module","app-main-coprate-mgmt-coprate-mgmt-module":"app-main-coprate-mgmt-coprate-mgmt-module","app-main-customer-management-customer-management-module":"app-main-customer-management-customer-management-module","app-main-dashboard-dashboard-module":"app-main-dashboard-dashboard-module","app-main-dispatch-management-dispatch-management-module":"app-main-dispatch-management-dispatch-management-module","app-main-endUser-end-user-module":"app-main-endUser-end-user-module","app-main-error-error-module":"app-main-error-error-module","app-main-information-information-module":"app-main-information-information-module","app-main-manage-geographics-manage-geographics-module":"app-main-manage-geographics-manage-geographics-module","app-main-profile-profile-module":"app-main-profile-profile-module","app-main-registrationModule-registrationModule-module":"app-main-registrationModule-registrationModule-module","app-main-tariff-management-tariff-management-module":"app-main-tariff-management-tariff-management-module","app-main-user-management-user-management-module":"app-main-user-management-user-management-module","canvg":"canvg","common":"common","app-main-booking-booking-module":"app-main-booking-booking-module","app-main-charger-station-charging-station-module":"app-main-charger-station-charging-station-module","app-main-client-client-module":"app-main-client-client-module","app-main-cpo-cpo-module":"app-main-cpo-cpo-module","app-main-driver-driver-module":"app-main-driver-driver-module","app-main-menu-master-menu-master-module":"app-main-menu-master-menu-master-module","app-main-miscellaneous-miscellaneous-module":"app-main-miscellaneous-miscellaneous-module","app-main-payment-payment-module":"app-main-payment-payment-module","default~app-main-logs-history-logs-history-module~app-main-ocpp-charger-profile-ocpp-charger-profile-module":"default~app-main-logs-history-logs-history-module~app-main-ocpp-charger-profile-ocpp-charger-profile-module","app-main-ocpp-charger-profile-ocpp-charger-profile-module":"app-main-ocpp-charger-profile-ocpp-charger-profile-module","app-main-logs-history-logs-history-module":"app-main-logs-history-logs-history-module","dompurify":"dompurify","html2canvas":"html2canvas","EV-dealers-EV-dealers-module":"EV-dealers-EV-dealers-module","EV-components--manufacturers-EV-components-manufacturers-module":"EV-components--manufacturers-EV-components-manufacturers-module","EV-fleet-EV-fleet-module":"EV-fleet-EV-fleet-module","subsidy-subsidy-module":"subsidy-subsidy-module","charger-charger-management-module":"charger-charger-management-module","alarm-configuration-alarm-configuration-module":"alarm-configuration-alarm-configuration-module","charger-model-charging-model-module":"charger-model-charging-model-module","charger-type-charger-type-module":"charger-type-charger-type-module","rfid-management-rfid-management-module":"rfid-management-rfid-management-module","vehicle-vehicle-module":"vehicle-vehicle-module","callback-callback-module":"callback-callback-module","coprate-user-coprate-user-module":"coprate-user-coprate-user-module","EV-charging-station-request-EV-charging-station-request-module":"EV-charging-station-request-EV-charging-station-request-module","register-charger-request-register-charger-request-module":"register-charger-request-register-charger-request-module","app-main-dashboard-project-project-module":"app-main-dashboard-project-project-module","app-main-dashboard-analytics-analytics-module":"app-main-dashboard-analytics-analytics-module","client-sales-dispatch-client-sales-dispatch-module":"client-sales-dispatch-client-sales-dispatch-module","end-user-map-end-user-map-module":"end-user-map-end-user-map-module","manage-city-manage-city-module":"manage-city-manage-city-module","manage-country-manage-country-module":"manage-country-manage-country-module","manage-state-manage-state-module":"manage-state-manage-state-module","manage-state-pin-manage-state-pin-module":"manage-state-pin-manage-state-pin-module","CPO-cpo-module":"CPO-cpo-module","User-user-module":"User-user-module","Vehicle-vehicle-module":"Vehicle-vehicle-module","customer-registration-customer-module":"customer-registration-customer-module","launch-tariff-launch-tariff-module":"launch-tariff-launch-tariff-module","manage-tariff-manage-tariff-module":"manage-tariff-manage-tariff-module","tax-setting-tax-setting-module":"tax-setting-tax-setting-module","end-user-end-user-module":"end-user-end-user-module","manage-role-permission-manage-role-permission-module":"manage-role-permission-manage-role-permission-module","manage-user-station-manage-user-station-module":"manage-user-station-manage-user-station-module","role-role-module":"role-role-module","user-role-activity-user-role-activity-module":"user-role-activity-user-role-activity-module","user-role-user-role-module":"user-role-user-role-module","user-user-module":"user-user-module","role-permission-role-permission-module":"role-permission-role-permission-module","app-main-booking-booking-config-booking-config-module":"app-main-booking-booking-config-booking-config-module","client-module-mapping-client-moduleMapping-module":"client-module-mapping-client-moduleMapping-module","app-main-driver-driver-rfid-driver-rfid-module":"app-main-driver-driver-rfid-driver-rfid-module","EV-charging-solution-EV-charging-solution-module":"EV-charging-solution-EV-charging-solution-module","notification-engine-notification-engine-module":"notification-engine-notification-engine-module","charging-profile-charging-profile-module":"charging-profile-charging-profile-module","EV-battery-manufacturers-EV-battery-manufacturers-module":"EV-battery-manufacturers-EV-battery-manufacturers-module","EV-charging-station-franchise-EV-charging-station-franchise-module":"EV-charging-station-franchise-EV-charging-station-franchise-module","EV-dealership-franchise-provider-EV-dealership-franchise-provider-module":"EV-dealership-franchise-provider-EV-dealership-franchise-provider-module","chargers-chargers-module":"chargers-chargers-module","product-dispatch-product-dispatch-module":"product-dispatch-product-dispatch-module","cpo-rfid-cpo-rfid-module":"cpo-rfid-cpo-rfid-module","rfid-recharge-rfid-recharge-module":"rfid-recharge-rfid-recharge-module","rfid-rfid-module":"rfid-rfid-module","vehicle-onBoard-vehicle-onBoard-module":"vehicle-onBoard-vehicle-onBoard-module","app-main-dashboard-project-monitoring-reports-monitoring-reports-module":"app-main-dashboard-project-monitoring-reports-monitoring-reports-module","app-main-dashboard-project-payment-reports-payment-reports-module":"app-main-dashboard-project-payment-reports-payment-reports-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
